import { type Theme, getResolvedTheme } from "@/shared/stores/theme.store";
import { Button, HStack, Spinner, VStack } from "@/shared/ui/primitives";
import { BlockNoteView } from "@blocknote/mantine";
import type { useCreateBlockNote } from "@blocknote/react";

type UpdatePrdEditorPanelProps = {
	editor: ReturnType<typeof useCreateBlockNote>;
	theme: Theme;
	isSaving: boolean;
	isStreaming: boolean;
	saveLabel: string;
	generateLabel: string;
	onSave: () => void;
	onGenerate: () => void;
};

export const UpdatePrdEditorPanel = ({
	editor,
	theme,
	isSaving,
	isStreaming,
	saveLabel,
	generateLabel,
	onSave,
	onGenerate,
}: UpdatePrdEditorPanelProps) => {
	const isActionDisabled = isSaving || isStreaming;

	return (
		<VStack className="relative w-full h-full rounded-[16px] outline-outline overflow-hidden">
			<HStack className="absolute top-[16px] right-[16px] gap-[10px] z-10">
				<Button onClick={onSave} disabled={isActionDisabled}>
					{isSaving ? <Spinner size="sm" /> : saveLabel}
				</Button>
				<Button variant="primary" onClick={onGenerate} disabled={isActionDisabled}>
					{generateLabel}
				</Button>
			</HStack>
			<div className="w-full h-full overflow-auto">
				<BlockNoteView
					editor={editor}
					theme={getResolvedTheme(theme)}
					className="w-full min-h-full py-[24px]"
				/>
			</div>
		</VStack>
	);
};
